import { getTrialInfo, claimTrial } from '@/services/TrialService.js';
import { getUserSubscriptions } from '@/services/SubscriptionService.js';

export default {
  async fetchTrialInfo(context, payload) {
    const schoolId = typeof payload === 'string' ? payload : payload.schoolId;
    const styleId = typeof payload === 'string' ? null : (payload.styleId || null);
    const packageId = typeof payload === 'string' ? null : (payload.packageId || null);
    context.commit('setLoading', true);
    try {
      const data = await getTrialInfo(schoolId, styleId, packageId);
      context.commit('setTrialInfo', data.data);
      context.commit('setAllTrialStyleIds', data.data.allTrialStyleIds || []);
    } finally {
      context.commit('setLoading', false);
    }
  },

  async claimTrial(context, { schoolId, danceStyleId, referredBy }) {
    context.commit('setLoading', true);
    try {
      const data = await claimTrial(schoolId, danceStyleId, referredBy);
      context.commit('addActiveTrialSub', data.data.subscription);
      return data.data.subscription;
    } finally {
      context.commit('setLoading', false);
    }
  },

  async loadMyActiveTrials(context) {
    const userId = context.rootGetters['auth/getCurrentUserId'];
    const token = context.rootGetters['auth/getToken'];
    if (!userId || !token) return;
    const data = await getUserSubscriptions(userId, token);
    const activeTrials = (data.data?.subscriptions || []).filter(
      (s) => s.isTrialSubscription && s.status === 'active',
    );
    context.commit('setActiveTrialSubs', activeTrials);
  },
};
